import * as Yup from "yup";
import { HolidayKind } from "../constants/holiday.constants";
import { HOLIDAY_START_YEAR } from "../utils/holidayYears";

function parseIsoYear(value: string | undefined): number | null {
  if (!value || value.length < 4) return null;
  const y = Number(value.slice(0, 4));
  return Number.isFinite(y) ? y : null;
}

export default Yup.object({
  name: Yup.string().trim().required("Name is required").max(200),
  date: Yup.string()
    .required("Date is required")
    .test("valid-year", function (value) {
      const maxYear = new Date().getFullYear() + 1;
      const year = parseIsoYear(value);
      if (year == null) {
        return this.createError({ message: "Enter a valid date" });
      }
      if (year < HOLIDAY_START_YEAR || year > maxYear) {
        return this.createError({
          message: `Date must be between ${HOLIDAY_START_YEAR} and ${maxYear}`,
        });
      }
      return true;
    }),
  kind: Yup.mixed<HolidayKind>()
    .oneOf(Object.values(HolidayKind) as HolidayKind[])
    .required("Kind is required"),
  isPaid: Yup.boolean(),
});
